import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-input',
  template: `
    <div class="field p-fluid mt-1">
      <input
        type="text"
        pInputText
        [formControl]="formControl"
        [formlyAttributes]="field"
      />
      <div
        *ngIf="showError && formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>

      <div
        *ngIf="
          field.templateOptions.description &&
          (!showError || !formControl.errors)
        "
        class="text-sm mt-2"
      >
        {{ field.templateOptions.description }}
      </div>
    </div>
  `,
})
export class InputTypeComponent extends FieldType<FieldTypeConfig> {}
